<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-info">
        <p class="logo-bottom">
          <svg xmlns="http://www.w3.org/2000/svg" width="179" height="35" viewBox="0 0 179 35" fill="none">
            <path
              d="M33.7477 12.8698V22.9733C33.7353 24.8349 33.2708 26.6534 32.3976 28.2315C31.258 30.2966 29.753 31.4124 28.7559 32.1459C26.8731 33.5391 24.7054 34.4884 22.3272 34.9754C22.2467 34.9939 22.1538 35 22.0609 35C21.9742 35 21.8875 34.9939 21.8007 34.9754C19.4163 34.4884 17.2548 33.5391 15.3721 32.1459C14.7218 31.6651 14.0776 31.1781 13.415 30.5C13.1672 30.2473 13.0372 29.9206 13.0434 29.5692C13.0434 29.224 13.1858 28.8973 13.4397 28.6507C13.9538 28.1514 14.7837 28.1637 15.2915 28.6754C15.8242 29.2178 16.3754 29.637 16.9328 30.05C18.4378 31.1596 20.1657 31.9363 22.0609 32.3617C23.9622 31.9363 25.6902 31.1596 27.189 30.05C28.056 29.4089 29.239 28.5336 30.0998 26.9801C30.7625 25.7719 31.1155 24.3849 31.1279 22.9671V13.9979C29.6539 13.7452 28.2047 13.363 26.8112 12.8698C25.1637 12.2903 23.5659 11.5383 22.0609 10.6383C20.5621 11.5383 18.9642 12.2903 17.3168 12.8698C15.9171 13.363 14.4678 13.7452 13 13.9979V21.3952C13 22.1164 12.4116 22.702 11.687 22.702C10.9624 22.702 10.374 22.1164 10.374 21.3952V12.8698C10.374 12.2164 10.8695 11.6554 11.526 11.5753C13.1982 11.3657 14.8456 10.9712 16.4373 10.4102C18.1591 9.79993 19.8127 8.99239 21.3486 7.99992C21.7822 7.72252 22.3396 7.72252 22.7731 7.99992C24.3152 8.99239 25.9627 9.79993 27.6906 10.4102C29.2761 10.9712 30.9297 11.3657 32.6019 11.5753C33.2584 11.6554 33.7477 12.2164 33.7477 12.8698Z"
              fill="#848A9C"
            />
            <path
              d="M23.3737 14.3492V15.1814C23.3613 17.0431 22.8968 18.8616 22.0235 20.4396C20.884 22.5109 19.3728 23.6205 18.3757 24.3541C16.4991 25.7472 14.3376 26.6965 11.9532 27.1835C11.8603 27.202 11.7736 27.2082 11.6868 27.2082C11.6001 27.2082 11.5134 27.202 11.4267 27.1835C9.04229 26.6965 6.87461 25.741 4.99803 24.3541C4.0009 23.6205 2.48973 22.5109 1.35634 20.4396C0.483081 18.8616 0.0123867 17.0492 0 15.1937V5.07793C0 4.42451 0.495468 3.86355 1.15196 3.78341C2.82417 3.57382 4.47779 3.1793 6.06329 2.61833C7.78504 2.01422 9.43866 1.20052 10.9746 0.208049C11.4081 -0.0693496 11.9655 -0.0693496 12.3991 0.208049C13.935 1.20052 15.5887 2.00806 17.3166 2.61833C18.9021 3.1793 20.5557 3.57382 22.2279 3.78341C22.5747 3.82656 22.8844 4.00533 23.1012 4.27656C23.3118 4.55396 23.4109 4.89917 23.3613 5.24437C23.318 5.58958 23.1445 5.8978 22.8658 6.11356C22.5871 6.32931 22.2465 6.41561 21.8997 6.37246C20.0417 6.13821 18.2022 5.7067 16.4371 5.07793C14.7835 4.49848 13.1918 3.74642 11.6868 2.84642C10.1881 3.74642 8.59017 4.49848 6.93655 5.07793C5.54305 5.57109 4.0938 5.95328 2.62598 6.20602V15.1814C2.63837 16.5992 2.99139 17.9862 3.65407 19.1883C4.51495 20.7479 5.69788 21.6232 6.56495 22.2582C8.06374 23.3677 9.78549 24.1445 11.6868 24.5698C13.5882 24.1445 15.3161 23.3677 16.8149 22.2582C17.6758 21.6232 18.8587 20.7479 19.7258 19.1883C20.3885 17.9862 20.7415 16.5992 20.7477 15.1752V14.3492C20.7477 13.628 21.3361 13.0424 22.0607 13.0424C22.7853 13.0424 23.3737 13.628 23.3737 14.3492Z"
              fill="#848A9C"
            />
            <path
              d="M44.7901 16.9568C43.7682 16.9568 43.2913 16.7349 42.7958 16.1616L42.127 15.3355C41.6501 14.7869 41.4705 14.3492 41.5572 13.3321L42.2199 5.78686H45.7748L45.5395 8.47454H50.9958L51.2312 5.78686H54.7862L53.9005 15.8842C53.8386 16.5684 53.4732 16.9568 52.8167 16.9568H44.7963H44.7901ZM45.9359 25.2664L45.8677 26.037C45.8615 26.1479 45.8739 26.2589 45.9544 26.3082L46.0288 26.4191C46.0783 26.4993 46.1588 26.4993 46.2393 26.4993H61.091L60.8309 29.4335H44.8211C43.8859 29.4335 43.6258 29.2424 43.1736 28.7185L42.7958 28.2808C42.3251 27.7075 42.2075 27.4301 42.3004 26.413L42.5543 23.5034C42.6038 22.9239 43.0745 22.628 43.7063 22.628H57.152C57.375 22.628 57.4927 22.5171 57.5112 22.326L57.5856 21.5061H42.7339L42.994 18.541H60.2982C60.93 18.541 61.2892 18.8986 61.2334 19.5273L60.93 23.0102C60.8123 24.3294 60.0133 25.2602 58.6942 25.2602H45.9359V25.2664ZM50.5066 13.9917L50.7357 11.3595H45.2794L45.1369 13.0054C45.1183 13.1965 45.1679 13.3074 45.236 13.4184L45.6138 13.8561C45.7129 13.967 45.8244 13.9917 45.9854 13.9917H50.5066ZM62.4597 5.60193L61.4254 17.3451H57.9014L58.9357 5.60193H62.4597Z"
              fill="#848A9C"
            />
            <path
              d="M72.9819 16.0259C72.8642 17.3698 72.1767 17.9986 70.8266 17.9986H66.6089L66.2249 22.3568C66.2002 22.6342 66.2683 22.8253 66.4169 23.0164L67.1354 23.9226C67.3397 24.1137 67.4698 24.1938 67.7175 24.1938H73.0376L72.7713 27.239H66.5718C65.4446 27.239 65.042 27.1034 64.3669 26.3082L63.2955 24.989C62.7009 24.2493 62.5647 23.9164 62.6761 22.628L63.2583 15.989C63.3141 15.3602 63.6733 15.0581 64.3298 15.0581H69.0677C69.3711 15.0581 69.6065 14.9225 69.6313 14.6205L70.0896 9.43619H63.9458L64.2121 6.41563H72.8642C73.5269 6.41563 73.7994 6.74235 73.7375 7.43276L72.9819 16.0198V16.0259ZM80.6059 5.76837L78.5683 28.9466H75.2053L76.2334 17.2588H73.6446L73.9109 14.2383H76.4997L77.2429 5.7622H80.6059V5.76837ZM82.2161 5.60193H85.6596L83.5911 29.113H80.1476L82.2161 5.60193Z"
              fill="#848A9C"
            />
            <path
              d="M90.1812 27.2452C89.0788 27.2452 88.6205 27.1096 87.9764 26.3144L86.8059 24.8904C86.2113 24.1506 86.0998 23.8178 86.2113 22.5294L87.5552 7.24783C87.6172 6.56358 87.9454 6.2307 88.6081 6.2307H99.7685L99.5022 9.25126H90.9616L90.4723 14.7931H97.9415L97.6814 17.7828H90.2122L89.822 22.252C89.7972 22.5232 89.8654 22.7205 90.0635 22.9363L90.8315 23.9226C91.0359 24.1137 91.1907 24.1938 91.4137 24.1938H99.2669L99.0006 27.239H90.1812V27.2452ZM107.597 5.60193L105.528 29.113H102.004L103.026 17.4808H99.2235L99.4898 14.4664H103.293L104.073 5.60809H107.597V5.60193Z"
              fill="#848A9C"
            />
            <path
              d="M117.643 8.89367H114.143L114.404 5.90393H133.529L133.268 8.89367H129.794L129.478 12.5122H132.953L132.692 15.5019H124.864L124.678 17.5855H133.553L133.287 20.6061H112.1L112.366 17.5855H121.13L121.315 15.5019H113.574L113.834 12.5122H117.333L117.649 8.89367H117.643ZM131.894 26.117L131.627 29.1623H115.977C114.899 29.1623 114.565 28.9403 114.007 28.3424L113.456 27.7383C112.88 27.1095 112.768 26.752 112.88 25.5437L113.19 22.0054H116.745L116.472 25.1061C116.454 25.328 116.472 25.4328 116.621 25.5992L116.893 25.9568C117.023 26.0677 117.129 26.1232 117.321 26.1232H131.9L131.894 26.117ZM120.851 12.5122H125.923L126.239 8.89367H121.167L120.851 12.5122Z"
              fill="#848A9C"
            />
            <path
              d="M144.305 9.3314L143.859 14.4355C143.76 15.5883 143.909 16.6855 144.361 17.5362C145.693 19.9527 147.216 22.363 148.901 24.8041L146.287 26.9739C144.72 24.7239 143.16 22.4184 141.853 20.0883C141.785 19.9219 141.673 19.6506 141.661 19.4287C141.58 19.7061 141.45 19.9219 141.326 20.0883C139.598 22.5047 137.74 24.8596 135.715 27.165L133.337 25.0506C135.393 22.665 137.375 20.1684 139.295 17.4808C139.834 16.6855 140.205 15.5575 140.311 14.4109L140.757 9.33756H135.356L135.628 6.26769H149.817L149.545 9.33756H144.312L144.305 9.3314ZM156.432 5.60193L154.363 29.113H150.839L152.908 5.60193H156.432Z"
              fill="#848A9C"
            />
            <path
              d="M157.521 17.0123C161.145 15.5883 163.38 14.6266 164.916 13.7451C165.616 13.3321 166.112 13.0054 166.44 12.7033C165.629 13.1718 164.415 13.4739 163.312 13.4739H158.159L158.401 10.7307H165.622C166.452 10.7307 166.923 10.6506 167.27 10.4841L167.425 8.70263H158.94L159.187 5.90398H170.267C170.93 5.90398 171.227 6.26152 171.165 6.94577L170.85 10.515C170.633 12.9561 169.958 14.3554 166.75 16.0814C164.755 17.154 162.204 18.2513 158.587 19.5951L157.521 17.0184V17.0123ZM176.467 19.6753C177.266 19.6753 177.718 20.1684 177.65 20.9636L177.024 28.0959C176.95 28.9219 176.411 29.4151 175.612 29.4151H160.29C159.466 29.4151 159.014 28.9219 159.082 28.0959L159.708 20.9636C159.776 20.1684 160.315 19.6753 161.145 19.6753H176.467ZM173.729 26.3637L174.052 22.6897H163.027L162.705 26.3637H173.729ZM179 5.60193L177.879 18.3314H174.355L175.476 5.60193H179Z"
              fill="#848A9C"
            />
          </svg>
        </p>
        <ul class="policy-links">
          <li>
            <button type="button" @click="showTermsModal" class="link-policy">이용약관</button>
          </li>
          <li>
            <button type="button" @click="showPrivacyModal" class="link-policy">개인정보처리방침</button>
          </li>
        </ul>
        <address class="address">
          <div class="company-name">
            <span>(주)오션블루</span>
            <span>대표이사 : 박주형</span>
          </div>
          <div class="company-info">
            <span>주소 : 06739 서울특별시 서초구 남부순환로364길 7-6 4층</span>
            <span>전화번호 : 1522-7607</span>
            <span>사업자등록번호 : 389-81-02332</span>
            <!-- <span>통신판매업신고 : 0000-서울OO-000</span> -->
          </div>
        </address>
      </div>

      <!-- 이용약관 : 모달 -->
      <TermsOfService :is-visible="isTermsVisible" @close="hideTerms" @confirm="hideTerms" />

      <!-- 개인정보 수집 및 이용 동의 : 모달 -->
      <PrivacyPolicy :is-visible="isPrivacyVisible" @close="hidePrivacy" @confirm="hidePrivacy" />
    </div>
  </footer>
</template>

<script setup>
// Composables
const route = useRoute();
const router = useRouter();

// Reactive state
const isTermsVisible = ref(false);
const isPrivacyVisible = ref(false);

// URL 파라미터 확인하여 모달 자동 오픈
const checkURLParams = () => {
  const query = route.query;

  // privacy=true 파라미터가 있으면 개인정보처리방침 모달 오픈
  if (query.privacy === "true") {
    showPrivacyModal();
    removeURLParam("privacy");
  }

  // terms=true 파라미터가 있으면 이용약관 모달 오픈
  if (query.terms === "true") {
    showTermsModal();
    removeURLParam("terms");
  }
};

// URL에서 특정 파라미터를 제거하고 히스토리 업데이트
const removeURLParam = (param) => {
  const query = { ...route.query };
  delete query[param];

  router
    .replace({
      path: route.path,
      query: query,
    })
    .catch(() => {}); // 같은 라우트로의 네비게이션 에러 방지
};

// 모달 표시 함수들
const showTermsModal = () => {
  isTermsVisible.value = true;
};

const showPrivacyModal = () => {
  isPrivacyVisible.value = true;
};

const hideTerms = () => {
  isTermsVisible.value = false;
};

const hidePrivacy = () => {
  isPrivacyVisible.value = false;
};

// 라우트 쿼리 변경 감지
watch(
  () => route.query,
  () => {
    checkURLParams();
  },
  { immediate: true },
);

// 컴포넌트 마운트 시 실행
onMounted(() => {
  checkURLParams();
});
</script>
